import React from 'react'
import { Tabs } from '@/shared/ui'
import { FinanceHeader } from '../components/FinanceHeader'
import { FinanceSummaryTab } from '../components/FinanceSummaryTab'
import { FinancePaymentsTab } from '../components/FinancePaymentsTab'
import { FinanceCustomersTab } from '../components/FinanceCustomersTab'
import { FinanceCostsTab } from '../components/FinanceCostsTab'
import { getCurrentMonthInput, monthInputToMonthStartDate } from '../utils/month'

export default function FinancePage() {
  const [tab, setTab] = React.useState<'resumo' | 'pagamentos' | 'clientes' | 'custos'>('resumo')
  const [month, setMonth] = React.useState<string>(() => getCurrentMonthInput())
  const [refreshKey, setRefreshKey] = React.useState(0)
  const [monthStartDate, setMonthStartDate] = React.useState<string>(() => monthInputToMonthStartDate(getCurrentMonthInput()))
  const [monthError, setMonthError] = React.useState<string | null>(null)

  React.useEffect(() => {
    try {
      setMonthStartDate(monthInputToMonthStartDate(month))
      setMonthError(null)
    } catch (e: any) {
      setMonthError(e?.message || 'Mês inválido')
    }
  }, [month])

  return (
    <div className="mx-auto w-full max-w-[1600px] px-2 pb-10 pt-4">
      <FinanceHeader
        month={month}
        onMonthChange={setMonth}
        onRefresh={() => setRefreshKey((n) => n + 1)}
        loading={false}
      />

      {monthError && <div className="mb-4 text-sm text-red-400">{monthError}</div>}

      <Tabs
        tabs={[
          { value: 'resumo', label: 'Resumo' },
          { value: 'pagamentos', label: 'Pagamentos' },
          { value: 'clientes', label: 'Clientes (risco)' },
          { value: 'custos', label: 'Custos' },
        ]}
        value={tab}
        onValueChange={(v) => setTab(v as any)}
      />

      <div className="mt-4">
        {tab === 'resumo' && !monthError && (
          <FinanceSummaryTab monthStartDate={monthStartDate} refreshKey={refreshKey} />
        )}
        {tab === 'pagamentos' && !monthError && (
          <FinancePaymentsTab monthStartDate={monthStartDate} refreshKey={refreshKey} />
        )}
        {tab === 'clientes' && (
          <FinanceCustomersTab refreshKey={refreshKey} />
        )}
        {tab === 'custos' && !monthError && (
          <FinanceCostsTab monthStartDate={monthStartDate} refreshKey={refreshKey} />
        )}
      </div>
    </div>
  )
}

